import styled, {css} from "styled-components";
import media from "styled-media-query";
import breakpoints from "../../framework/helpers/BreakpointHelper/BreakpointHelper";
import {H1, H2} from "BaseComponents/Text";
import {FlexContainer} from "BaseComponents/Flex";
import {
    StyledBackgroundImage,
    ImageWrapper,
} from "../../framework/lazy/StyledBgImage";

export const Header = styled(H1)`
  & {
    line-height: 56px;
    margin-bottom: 10px;
    ${media.lessThan(breakpoints.mobile)`
			line-height: 42px;
		`}
  }
`;

export const HeaderH2 = styled(H2)`
  & {
    font-size: 50px;
    line-height: 56px;
    margin-bottom: 10px;
    ${media.lessThan(breakpoints.mobile)`
			line-height: 42px;
		`}
  }
`;

export const OuterHeroTextWrapper = styled.div`
  padding: ${({padding}) => (padding ? padding : 0)};
  display: ${({showBlock}) => (showBlock ? "flex" : "none")};
  margin: 0 auto;
  max-width: 1376px;
  z-index: ${({isVideo}) => (isVideo ? "1" : "0")};
  width: 100%;
  ${({height}) =>
      height && css`
            height: ${({height}) => height};
  `}
  ${media.lessThan(breakpoints.mobile)`
	height: 100%;
  `}

  ${media.greaterThan(breakpoints.mobile)`
        padding: ${({mobilePadding}) => (mobilePadding ? mobilePadding : "2rem 4rem 4rem 1rem")};
  	`}
  ${media.greaterThan(breakpoints.ipad)`
	    padding: ${({ipadPadding}) => (ipadPadding ? ipadPadding : "2rem 4rem 4rem 2rem")};
  `}

	${media.greaterThan(breakpoints.ipadPlus)`
	    padding: 2rem 4rem 4rem 2rem;
 	`}
   ${media.greaterThan(breakpoints.ipadPlus)`
    ${({ heroCurvedTextArea }) =>
      heroCurvedTextArea &&
      css`
        position: absolute;
        height: 849px;
        width: 100%;
        max-width: 756px;
        padding: 0;
      `}
  `}
  ${media.greaterThan(breakpoints.ipadPlus)`
  ${({ heroCurvedTextArea }) =>
    heroCurvedTextArea &&
    css`
      max-width: 50%;
    `}
   `}
  
  ${media.greaterThan(breakpoints.desktop)`
    ${({heroCurvedTextArea}) => heroCurvedTextArea &&
          css`
            max-width: 47%;
          `}
  `}
`;
export const CurvedHeroTextWrapper = styled("div").attrs(() => ({
    id: "CurvedHeroTextWrapper",
}))`
  padding: 1rem 3rem 1rem;
  display: flex;
  background-color: ${({bgColor}) => bgColor};
  flex-direction: ${({column}) => (column ? "column" : "row")};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "")};
  border-radius: ${({theme}) => theme.border.radius};
  z-index: 1;
  width: ${({theme}) => theme.grid.outer};
  margin: 0 auto;

  ${({alignItems}) =>
          alignItems &&
          css`
            align-items: ${({alignItems}) => alignItems};
          `}
  ${media.lessThan(breakpoints.ipad)`
	padding: 1rem;
    margin: 0;
    width: ${({CurvedHeaderMaxWidth}) => (CurvedHeaderMaxWidth ? CurvedHeaderMaxWidth : '450px')};    
	max-width:100%;
	align-items: ${({align}) => (align ? align : "center")};
  `}
  ${media.lessThan(breakpoints.mobile)`
		width: 100%;
		height: 100%;
    justify-content: center;
    margin: 0;
    border-radius: 0;   
		`} & {
    background: ${(props) =>
            props.backgroundColor ? props.backgroundColor : ""};
    display: ${(props) => (props.display ? props.display : "")};
    height: ${(props) => (props.height ? props.height : "")};
  }

  & {
    padding: ${(props) => (props.padding ? props.padding : "")};
    margin: ${(props) => (props.margin ? props.margin : "")};
    width: ${(props) => (props.width ? props.width : "")};
  }

  ${media.greaterThan(breakpoints.ipadPlus) &&
  media.lessThan("1367px")`
	  padding-left: 2rem;
    max-width: 50%;
    margin: 0;
  `}
`;
export const HeroTextWrapper = styled("div").attrs(() => ({
    id: "HeroTextWrapper",
}))`
  padding: 1rem 3rem 1rem 2rem;
  display: flex;
  background-color: ${({bgColor}) => bgColor};
  flex-direction: ${({column}) => (column ? "column" : "row")};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "")};
  border-radius: ${({theme}) => theme.border.radius};
  max-width: ${({ largeMaxWidth }) => (largeMaxWidth ? largeMaxWidth : "")};
  ${media.lessThan(breakpoints.ipadPlus)`
		padding: 1rem;

    ${({heroCurvedTextArea}) =>
          heroCurvedTextArea
                  ? css`
                    width: 100%;
                    height: 100%;
                    justify-content: center;
                    background: ${(props) =>
                            props.backgroundColor ? props.backgroundColor : ""};
                    display: ${(props) => (props.display ? props.display : "")};
                    height: ${(props) => (props.height ? props.height : "")};
                  `
                  : css`
                    width: ${({CurvedHeaderMaxWidth}) => (CurvedHeaderMaxWidth ? CurvedHeaderMaxWidth : '450px')};
                  `}
		max-width:100%;
		align-items: ${({align}) => (align ? align : "center")};
		

  `} ${media.lessThan(breakpoints.mobile)`
		width: 100%;
		height: 100%;
    justify-content: center;
    ${({heroCurvedTextArea}) =>
          heroCurvedTextArea
                  ? css`
                    border-top-right-radius: 9999px;
                    border-bottom-right-radius: 9999px;
                  `
                  : css`
                    border-radius: 0;
                  `}
		`} & {
    background: ${(props) =>
            props.backgroundColor ? props.backgroundColor : ""};
    display: ${(props) => (props.display ? props.display : "")};
    height: ${(props) => (props.height ? props.height : "")};
  }

  & {
    padding: ${(props) => (props.padding ? props.padding : "")};
    margin: ${(props) => (props.margin ? props.margin : "")};
    width: ${(props) => (props.width ? props.width : "")};
  }

  ${({heroCurvedTextArea}) =>
          heroCurvedTextArea &&
          css`
            width: 100%;
            border-top-right-radius: 9999px;
            border-bottom-right-radius: 9999px;
            align-items: center;
            justify-content: flex-end;
          `}
`;

export const HeroImageWrapper = styled.div`
  ${media.lessThan(breakpoints.ipad)`
    height: 250px;
  `}
  ${media.lessThan(breakpoints.mobile)`
    height: 200px;
  `}
`;
export const HeroWrapper = styled(FlexContainer).attrs(
    ({alignItems, backgroundImage, heroCurvedTextArea}) => ({
        backgroundImage: `url(${backgroundImage})`,
        alignment: alignItems ? alignItems : "center",
        smallAlignContent: alignItems ? alignItems : "center",
        smalldirection: "column",
        heroCurvedTextArea,
    })
)`
  & {
    ${media.lessThan(breakpoints.ipadPlus)`
		min-height: 46vh;
		align-items:stretch;

  `}

    ${ImageWrapper} {
      height: 100%;
    }

    ${StyledBackgroundImage} {
      border-radius: 0;
      display: flex;
      align-items: center;
    }

    ${media.greaterThan(breakpoints.mobile) &&
    media.lessThan(breakpoints.ipadPlus)`     
        ${({ heroCurvedTextArea }) =>
          heroCurvedTextArea &&
          css`
            height: auto;
            min-height: 46vh;
            align-items: stretch;
          `} 
      `}
    ${media.greaterThan(breakpoints.ipadPlus)`
		  height: 433px;
		  align-items: center;
    `}
    ${({heroCurvedTextArea}) =>
            heroCurvedTextArea &&
            css`
              ${media.lessThan(breakpoints.ipad)`        
          align-items: stretch;
        `}
            `}
    .splide__pagination__page {
      background: ${({theme}) => theme.colors.primary};

      &:focus {
        outline: none;
      }
    }
  }
}
`;
